import { FaChevronDown } from 'react-icons/fa';
import { colors } from '../../../../../colors';
import './index.css';

const ScrollIndicator = ({ hasScrolled }: { hasScrolled: boolean }) => {
  return (
    <div
      style={{
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        opacity: hasScrolled ? 0 : 1,
        transition: 'opacity 0.5s ease-in-out',
      }}
      className={`mover ${!hasScrolled ? 'animate' : ''}`}
    >
      <FaChevronDown
        color={colors.gray}
        size={24}
        className={'chevron chevron-down'}
      />
    </div>
  );
};

export default ScrollIndicator;
